import React from "react";

const ComingSoonPage = () => {
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50">

      <div className="relative inline-flex items-center gap-3 bg-gradient-to-r from-[#fff7dc] to-[#fff1b8] border border-[#efd372] px-5 py-3 rounded-full shadow-[0_10px_30px_rgba(212,175,55,0.18)] backdrop-blur-xl overflow-hidden animate-float">

        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shine"></div>

        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>

          <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
        </span>

        <p className="relative z-10 text-[11px] sm:text-[12px] font-black tracking-[0.2em] uppercase text-voyage-cyan whitespace-nowrap">
          Early Access Opens In Fews Weeks
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPage;